/**
 * 🧹 Cache Buster - принудительная очистка браузерного кэша
 */

// debugMode is already defined globally in params.js


// Проверяем версию скриптов
function checkScriptVersions() {
    const scripts = document.querySelectorAll('script[src]');
    const scriptVersions = [];
    
    scripts.forEach(script => {
        const src = script.src;
        if (src.includes('phase3-force-reload-diagnostic')) {
            if (debugMode === '1') {
                console.log('❌ СТАРЫЙ ДИАГНОСТИЧЕСКИЙ СКРИПТ ОБНАРУЖЕН В DOM!');
                console.log('🚨 Это кэшированная версия HTML!');
            }
            scriptVersions.push({file: 'phase3-force-reload-diagnostic.js', status: 'cached'});
        }
        if (src.includes('syntax-fix-test')) {
            scriptVersions.push({file: 'syntax-fix-test.js', status: 'present'});
        }
        if (src.includes('unzip-override')) {
            scriptVersions.push({file: 'unzip-override.js', status: 'present'});
        }
    });
    
    return scriptVersions;
}

// Принудительная очистка кэша Service Worker
async function clearServiceWorkerCache() {
    if ('serviceWorker' in navigator) {
        try {
            const registrations = await navigator.serviceWorker.getRegistrations();
            for (let registration of registrations) {
                await registration.unregister();
                if (debugMode === '1') {
                    console.log('✅ Service Worker unregistered');
                }
            }
        } catch (error) {
            if (debugMode === '1') {
                console.log('ℹ️ No Service Workers to clear');
            }
        }
    }
}

// Очистка всех кэшей
async function clearAllCaches() {
    if ('caches' in window) {
        try {
            const cacheNames = await caches.keys();
            await Promise.all(
                cacheNames.map(cacheName => caches.delete(cacheName))
            );
            if (debugMode === '1') {
                console.log('✅ All browser caches cleared');
            }
        } catch (error) {
            if (debugMode === '1') {
                console.log('ℹ️ No caches to clear');
            }
        }
    }
}

// Очистка Local Storage (кроме важных данных)
function clearLocalStorageCache() {
    const keysToKeep = ['auth_token', 'user_preferences', 'filesList'];
    const allKeys = Object.keys(localStorage);
    
    // Explicitly remove old lectures cache keys (legacy)
    const lecturesKeys = ['lectures.en.cache', 'lectures.en.lastModified', 'lectures.en.lastModified.server'];
    lecturesKeys.forEach(key => {
        if (localStorage.getItem(key)) {
            localStorage.removeItem(key);
            if (debugMode === '1') {
                console.log(`✅ Removed legacy lectures cache: ${key}`);
            }
        }
    });
    
    allKeys.forEach(key => {
        if (!keysToKeep.includes(key) && key.includes('cache')) {
            localStorage.removeItem(key);
            if (debugMode === '1') {
                console.log(`✅ Removed cached item: ${key}`);
            }
        }
    });
}

// Основная функция очистки
async function performCacheBust() {
    if (debugMode === '1') {
        console.log('🧹 Starting cache bust operation...');
    }
    
    const versions = checkScriptVersions();
    if (debugMode === '1') {
        console.log('📊 Script versions:', versions);
    }
    
    // Очищаем все виды кэшей
    await clearServiceWorkerCache();
    await clearAllCaches();
    clearLocalStorageCache();
    
    // Добавляем timestamp к URLs для принудительного обновления
    const timestamp = Date.now();
    window.cacheBustTimestamp = timestamp;
    
    if (debugMode === '1') {
        console.log('✅ Cache bust completed!');
        console.log(`🕐 Timestamp: ${timestamp}`);
    }
    console.log('💡 Recommendation: Hard reload (Ctrl+Shift+R) to see changes');
    
    return timestamp;
}

// Автоматический запуск если обнаружены проблемы с кэшем
setTimeout(async () => {
    const versions = checkScriptVersions();
    const hasCacheIssues = versions.some(v => v.status === 'cached');
    
    if (hasCacheIssues) {
        if (debugMode === '1') {
            console.log('🚨 Cache issues detected, performing automatic cache bust...');
        }
        await performCacheBust();
        
        // Предлагаем перезагрузку
        if (debugMode === '1') {
            console.log('');
            console.log('🔄 CACHE CLEANED! Please reload page:');
            console.log('1. Press Ctrl+Shift+R (Chrome) or Ctrl+F5');
            console.log('2. Or go to DevTools > Application > Storage > Clear Storage > Clear site data');
            console.log('3. Then refresh the page');
        }
    } else {
    }
}, 1000);

// Глобальный доступ к функции
window.cacheBust = performCacheBust;
